module.exports = __webpack_public_path__ + "img/cu03.c95deda6.jpg";